window.simpleTabs = function simpleTabs() {

    $('.js_offerTopTabs li a, .js_simpleTabs li a').on('click', function (e) {
        e.preventDefault();
        var $this = $(this),
            parent = $this.parent(),
            data_tab = parent.data('tab');

        parent.addClass('active').siblings().removeClass('active');

        console.log(parent)
        console.log($this);
        console.log({data_tab})

        if ($this.hasClass('js_triggerSimpleTab')) {
            console.log('has class')
            $('.simpleTabs__tabBody:not([data-tab="' + data_tab + '"])').hide();
            $('.simpleTabs__tabBody[data-tab="' + data_tab + '"]').show();
        } else {
            $('.offerTopTab:not([data-tab="' + data_tab + '"])').hide();
            $('.offerTopTab[data-tab="' + data_tab + '"]').show();
        }

    });
}

$(document).ready(function () {
    'use strict';

    simpleTabs();
});